import { handleSendFunctionResponseToRFPAgent } from "../services/handleSendFunctionResponseToRFPAgent";
import { activateRainbowRing } from "../utilities/rainbowRingFunctions";

export const changeSingleValue = async (section, value, updatedChatSession, documentData, setDocumentData, chatSessionRef, setChatSession, userInfo) => {
    const updatedDocumentData = { ...documentData }; 
    updatedDocumentData[section] = value; 
    setDocumentData(updatedDocumentData); 
    const responseMessage = `FunctionResponse: The value of ${section} has been changed to ${updatedDocumentData[section]}}. Confirm that this is the intended change (silently). If not, run it again. If so, respond letting the user know that the change has been made successfully and either provide suggestions for further improvement or ask the user how else you can help.`;
    const response = {
        role: "user",
        parts: [
          {
            text: responseMessage
          }
        ]
    }
    activateRainbowRing();
    await handleSendFunctionResponseToRFPAgent(response, updatedChatSession, setChatSession, chatSessionRef, userInfo);
}